import React from "react";
import Checkbox from "components/Auth/atoms/forms/CheckboxCostum";
import Icon from "components/MainApp/atoms/Icon/icon";
import BarcodeImg from "./CodigoBarras.svg";
import styles from "./MainApp.organisms.Tags.Tag.module.scss";

const Item = ({
  tag,
  handleDelete,
  handleSelect,
  selected,
  type
}) => {
  return (
    <div className={styles["tag-container"]}>
      <div className={styles["left-container"]}>
        {handleSelect && (
          <div className={styles["tag-selector"]} onClick={() => handleSelect(tag)}>
            <Checkbox checked={selected} />
          </div>
        )}
        <div className={styles["tag"]}>
          <div className={type !== undefined ? styles["tag-rfid"] : `${styles["tag-rfid"]} ${styles["tag-rfid-step2"]}`}>{tag.rfid}</div>
          <div className={type !== undefined ? styles["tag-epc"] : `${styles["tag-epc"]} ${styles["tag-epc-step2"]}`}>{tag.epc}</div>
          {tag.barcode && (
            <>
              <img src={BarcodeImg} />
              <div className={styles["barcode"]}>{tag.barcode}</div>
            </>
          )}
        </div>
      </div>

      {handleDelete && (
        <div onClick={() => handleDelete(tag)}>
          <Icon name="trash_can" width={20} height={20} fill={"#3C7AF5"} />
        </div>
      )}

    </div>
  );
};

export default Item;
